/**
 * How the JSX runtime reaches the translation.
 *
 * The runtime (`jsx-runtime.ts`) is named to the build tools as the place JSX comes from,
 * and a tool may load it apart from the rest of the app — the dev server bundles it on its
 * own, as it does a package. Had the runtime imported the language directly it would then
 * hold a second copy of it: the app would change language and the screens would not.
 *
 * So the runtime imports nothing of ours that keeps state. It asks, through this one slot
 * on the page, for whatever translation the app has put there; `render.ts` puts it there.
 */
type ShownProps = <P>(type: unknown, props: P) => P;

const SLOT = Symbol.for('qmi.i18n.shownProps');
const page = globalThis as unknown as Record<symbol, ShownProps | undefined>;

export function provideTranslation(shownProps: ShownProps): void {
  page[SLOT] = shownProps;
}

/** The props as they are to be shown: translated when the app has a translation in place. */
export function shown<P>(type: unknown, props: P): P {
  const translate = page[SLOT];
  return translate ? translate(type, props) : props;
}
